$(document).ready(function() {
    var url = window.location.href;
    var activePage = url;
    $('.paginate a').each(function (i) {
        var linkPage = this.href;
        i = i+1;

        if (linkPage == window.location.protocol + '//' + window.location.host + '/blog/page1') {
            $(this).attr("href", "/blog");
        }
        if (linkPage == window.location.protocol + '//' + window.location.host + '/testimonials/page1') {
            $(this).attr("href", "/testimonials");
        }
        if (linkPage == window.location.protocol + '//' + window.location.host + '/blog/tags/') {
            $(this).attr("href", "/blog/tags/"+getUrlTag);
        }
        if (linkPage.substring(0, linkPage.length -1) == window.location.protocol + '//' + window.location.host + '/blog/tags/?page=') {
            $(this).attr("href", "/blog/tags/"+getUrlTag+"/page"+i);
        }

        if (activePage == linkPage ) {
            $(this).closest("li").addClass("active");
        }
        if(activePage == window.location.protocol + '//' + window.location.host + '/blog/tags/'+getUrlTag+'/page'+i) {
            $(this).closest("li").addClass("active");
        }

        if (activePage == window.location.protocol + '//' + window.location.host + '/blog' ) {
            $('.pagination li').first().addClass('active');
        }
        if (activePage == window.location.protocol + '//' + window.location.host + '/testimonials' ) {
            $('.pagination li').first().addClass('active');
        }
        if (activePage == window.location.protocol + '//' + window.location.host + '/blog/tags/'+getUrlTag) {
            $('.pagination li').first().addClass('active');
        }

    });
});